import { ArrowLeft, ArrowRight, X, Plus } from "lucide-react";

export const PIECE_LABELS = {
  site_name: "Site name",
  site_number: "Site number",
  description: "Photo description",
  date: "Date taken",
  customer: "Customer name",
};

// Ordered chips with move/remove, plus add buttons for unused pieces.
export default function NamingPieces({ parts, allParts, onChange }) {
  const move = (i, d) => {
    const next = [...parts];
    [next[i], next[i + d]] = [next[i + d], next[i]];
    onChange(next);
  };
  const unused = allParts.filter((p) => !parts.includes(p));
  return (
    <div className="space-y-2">
      <div className="text-[10px] uppercase tracking-wider text-slate-500">Name order</div>
      <div className="flex flex-wrap gap-2" data-testid="naming-pieces">
        {parts.map((p, i) => (
          <span key={p} className="inline-flex items-center gap-1 rounded-full bg-sky-950/50 border border-sky-800 pl-3 pr-1 py-1 text-xs text-sky-100" data-testid={`naming-piece-${p}`}>
            <span className="text-sky-400 font-mono mr-1">{i + 1}</span>{PIECE_LABELS[p]}
            <button type="button" disabled={i === 0} onClick={() => move(i, -1)} className="p-1 rounded hover:bg-sky-900 disabled:opacity-30" aria-label="Move earlier" data-testid={`naming-piece-left-${p}`}><ArrowLeft className="w-3 h-3" /></button>
            <button type="button" disabled={i === parts.length - 1} onClick={() => move(i, 1)} className="p-1 rounded hover:bg-sky-900 disabled:opacity-30" aria-label="Move later" data-testid={`naming-piece-right-${p}`}><ArrowRight className="w-3 h-3" /></button>
            <button type="button" disabled={parts.length === 1} onClick={() => onChange(parts.filter((x) => x !== p))} className="p-1 rounded hover:bg-red-900 disabled:opacity-30" aria-label="Remove" data-testid={`naming-piece-remove-${p}`}><X className="w-3 h-3" /></button>
          </span>
        ))}
      </div>
      {unused.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {unused.map((p) => (
            <button key={p} type="button" onClick={() => onChange([...parts, p])} className="inline-flex items-center gap-1 rounded-full border border-dashed border-slate-600 px-3 py-1 text-xs text-slate-300 hover:border-sky-500 hover:text-sky-200 transition-colors" data-testid={`naming-add-${p}`}>
              <Plus className="w-3 h-3" />{PIECE_LABELS[p]}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
